import { render } from "./CommandesPage.vue?vue&type=template&id=0dee47b6&scoped=true"
import script from "./CommandesPage.vue?vue&type=script&lang=js"
export * from "./CommandesPage.vue?vue&type=script&lang=js"

import "./CommandesPage.vue?vue&type=style&index=0&id=0dee47b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dee47b6"]])

export default __exports__